
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import { AxiosResponse } from "axios";
import { onScroll } from "@/functions/global.function";

import Jobs1 from "@/components/content-management/jobs/Jobs1.vue";
import Jobs2 from "@/components/content-management/jobs/Jobs2.vue";
import Jobs4 from "@/components/content-management/jobs/Jobs4.vue";

@Component({
  components: {
    Jobs4,
    Jobs2,
    Jobs1,
  },
  filters,
})
export default class Jobs extends Vue {
  @Action("getSchoolJobs", { namespace: "school" })
  private getSchoolJobs: any;

  @Prop({ default: 1 })
  private templateNumber!: number;

  private jobs: Array<any> = [];
  private page = 1;
  private isLastPage = false;
  private isLoading = false;

  private getData(isReload: boolean = false) {
    if (isReload) {
      this.jobs = [];
      this.page = 1;
      this.isLastPage = false;
    }
    if (!this.isLoading && !this.isLastPage) {
      this.getSchoolJobs({
        params: {
          page: this.page,
        },
        success: (response: AxiosResponse) => {
          const isLastPage = response.data.data.last_page === this.page;
          this.jobs = [...this.jobs, ...response.data.data.data];
          this.page = isLastPage ? this.page : this.page + 1;
          this.isLastPage = isLastPage;
        },
      });
    }
  }

  private created() {
    this.getData();
  }

  private mounted() {
    onScroll(".job-list", this.getData);
  }
}
